import { NgModule } from '@angular/core';
import { downgradeComponent } from '@angular/upgrade/static';
import { SimpleAngularComponent } from './simple-angular/simple-angular.component';
import { NestedAngularjsComponent } from './nested-angularjs/nested-angularjs.component';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@core/core.module';
import { PlannerExampleComponent } from './planner-example/planner-example.component';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';
import { PermissionGuard } from '@core/guards/permission.guard';

let ANGULAR_ROUTES_STATES = [
  // declare here all new routes you want to use
  // for this module
  {
    parent: 'app',
    name: 'angular-route',
    url: '/angular-route',
    component: NestedAngularjsComponent,
    canActivate: [PermissionGuard],
    data: {permission: 'APP.COMPLAINTS.USER'}
}];

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    UIRouterUpgradeModule.forChild({ 
      states: ANGULAR_ROUTES_STATES 
    })
  ],
  declarations: [
    SimpleAngularComponent,
    NestedAngularjsComponent,
    PlannerExampleComponent,
  ],
  exports: [
    SimpleAngularComponent,
    NestedAngularjsComponent,
    PlannerExampleComponent,
  ]
}) 
export class AngularjsAngularExamplesModule { }

export function bindAngularjsAngularExamplesToAngularJs(angular : any) {
  angular.directive('simpleAngular', downgradeComponent({ component: SimpleAngularComponent }));
  angular.directive('plannerExample', downgradeComponent({ component: PlannerExampleComponent }));
}
